import { createSlice } from "@reduxjs/toolkit";

const fixedSlice = createSlice({
    name: "fixed",
    initialState: {},
    reducers: {
        set_user_agent: (state, action) => {
            if (typeof action.payload.isWebView === "boolean") {
                return {
                    ...state,
                    ...action.payload,
                };
            }
        },
    },
});

export const { set_user_agent } = fixedSlice.actions;

export default fixedSlice.reducer;
